import { UserInfo } from "../api"

const actions = {
    banner (state, res){
        state.commit('banner', res)
    },
    userInfo (state, res) {
        state.commit('userInfo', res)
    }
}

export default actions